import { api } from './api';
import type {
  QuizWithQuestions,
  CreateQuizDto,
  UpdateQuizDto,
  StartQuizAttemptDto,
  SubmitQuizAttemptDto,
  QuizAttemptWithRelations,
  QuizStats,
} from '@xtreed/academy-shared';

class QuizzesService {
  async findAll(lessonId?: string): Promise<QuizWithQuestions[]> {
    const params = lessonId ? { lessonId } : {};
    const response = await api.get('/quizzes', { params });
    return response.data;
  }

  async findOne(id: string): Promise<QuizWithQuestions> {
    const response = await api.get(`/quizzes/${id}`);
    return response.data;
  }

  async create(data: CreateQuizDto): Promise<QuizWithQuestions> {
    const response = await api.post('/quizzes', data);
    return response.data;
  }

  async update(id: string, data: UpdateQuizDto): Promise<QuizWithQuestions> {
    const response = await api.patch(`/quizzes/${id}`, data);
    return response.data;
  }

  async remove(id: string): Promise<void> {
    await api.delete(`/quizzes/${id}`);
  }

  async getStats(id: string): Promise<QuizStats> {
    const response = await api.get(`/quizzes/${id}/stats`);
    return response.data;
  }

  // === QUIZ ATTEMPTS ===

  async startAttempt(
    data: StartQuizAttemptDto,
  ): Promise<QuizAttemptWithRelations> {
    const response = await api.post('/quizzes/attempts/start', data);
    return response.data;
  }

  async submitAttempt(
    data: SubmitQuizAttemptDto,
  ): Promise<QuizAttemptWithRelations> {
    const response = await api.post('/quizzes/attempts/submit', data);
    return response.data;
  }

  async getMyAttempts(quizId?: string): Promise<QuizAttemptWithRelations[]> {
    const params = quizId ? { quizId } : {};
    const response = await api.get('/quizzes/attempts/my', { params });
    return response.data;
  }

  async getUserAttempts(
    userId: string,
    quizId?: string,
  ): Promise<QuizAttemptWithRelations[]> {
    const params = quizId ? { quizId } : {};
    const response = await api.get(`/quizzes/users/${userId}/attempts`, {
      params,
    });
    return response.data;
  }
}

export const quizzesService = new QuizzesService();
